<app-header icon="back" title="Invite Participants" showNav="false"></app-header>

<div class="invite-page p-3">
  <div class="page-padding">
   <h4>Invite Participants to sign up for Spots*</h4>
  </div>
  <app-share></app-share>
  <div><small>* Please visit our desktop version to send private individual invitations or to get a html SignUp button for your website or blog.</small></div>
</div>